export default __webpack_public_path__ + "f340fe20b13ed9021e28e2846ab82122.png";